<template>
    <div class="pano-container">
        <mui-errorloading v-if="isPanoError"/>
        <!-- 层级问题用的 -->
        <loading v-else-if="!isPanoReady"/>
        <!-- 全景容器 -->
        <div
            ref="sharePano"
            class="anspano"
        ></div>
        <div class="cover" @click="backToNative">
            <p>这里是{{ decodeURIComponent(cityName) }}，我仅用1S就认出了这里！快来挑战我吧！</p>
            <p>赢取GoPro、无人机大礼！</p>
        </div>
    </div>
</template>

<script>
let panoEntity = null;
import * as Pano from '@baidu/pano-viewer';
import {mapState, mapActions} from 'vuex';
import Loading from '../../components/Loading/Loading';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import {jumpByOpenapi} from '@/pages/pano-game/constant/JumpFunc';
import {initQuestionShare} from '@/pages/pano-game/constant/ShareConfig';

export default {
    name: 'Share',
    data() {
        return {
            isPanoReady: false,
            panoLoading: true,
            pid: '', // 当前答题的 pid
            isPanoError: false,
            cityName: ''
        };
    },
    components: {
        Loading
    },
    computed: {
        ...mapState(['urlParams', 'isNative'])
    },
    created() {
        initQuestionShare();
    },
    mounted() {
        this.getUrlParams();
        this.pid = this.urlParams.pid;
        this.cityName = decodeURIComponent(this.urlParams.cityName);
        this.initApplication(this.urlParams.pid);
        // 根据页面参数初始化分享页面
        initQuestionShare({
            // wxPic: this.staticImgData.shareWxImgUrl,
            // weiboPic: this.staticImgData.shareWbImgUrl,
            // wxText: this.staticImgData.shareWbWxText,
            // wxFriendText: this.staticImgData.shareWbWxText,
            // weiboText: this.staticImgData.shareWbWxText,
            url: location.origin + location.pathname
                + `?pid=${this.urlParams.pid}`
                + `&cityName=${encodeURIComponent(decodeURIComponent(this.urlParams.cityName))}#/share`
        });
        StatisticConst.outNative('ansRight');
    },
    methods: {
        ...mapActions([
            'getUrlParams'
        ]),
        initApplication(answerPid) {
            panoEntity = Pano.init(this.$refs.sharePano, {
                maxPitch: 90,
                maxImageZoom: 5,
                enableCapture: false,
                // 关闭拓扑箭头
                linksControl: true
            });
            window.pano = panoEntity;
            // this.bindDOMEvents();
            panoEntity.setId(answerPid);
            // TODO: 逻辑待优化
            this.panoLoading = false;
            // 绑定事件
            this.bindPanoEvents();
        },

        /**
         * 绑定DOM事件
         */
        // bindDOMEvents() {
        //     document.documentElement.style.fontSize = screen.width + 'px';
        // },

        bindPanoEvents() {
            panoEntity.on('thumb_loaded', () => {
                // 以第一张全景缩略图加载完成作为全景ready的判断条件
                if (this.isPanoReady === false) {
                    this.isPanoReady = true;
                }
            });
            panoEntity.on('pano_error', e => {
                this.isPanoError = true;
            });
        },
        backToNative() {
            jumpByOpenapi(location.origin + location.pathname);
            !this.isNative && StatisticConst.outNativeBackNative('ansRight');
        }
    },
    destroyed() {
    }
};
</script>
<style src="./Share.scss" lang="scss"></style>
